import { LoadingOutlined } from '@ant-design/icons';
import type { PropsWithChildren, ReactNode } from 'react';

import './LoadingOverlay.scss';

import { cNs } from 'src/helpers';

type LoadingOverlayProps = PropsWithChildren<{
  className?: string;
  isFirstLoading?: boolean;
  isLoading?: boolean;
  loadingComponent?: ReactNode | ((component: ReactNode) => ReactNode);
  indicatorSize?: number;
}>;

function LoadingIndicator({ indicatorSize }: Readonly<Pick<LoadingOverlayProps, 'indicatorSize'>>) {
  return (
    <div className="loading-overlay__loading-indicator">
      <LoadingOutlined style={{ fontSize: indicatorSize }} spin={true} />
    </div>
  );
}

export function LoadingOverlay({
  className,
  isFirstLoading,
  isLoading,
  loadingComponent,
  indicatorSize = 24,
  children,
}: LoadingOverlayProps) {
  return (
    <div className={cNs('loading-overlay', (isFirstLoading || isLoading) && 'loading-overlay__loading', className)}>
      {isFirstLoading ? (
        ((typeof loadingComponent === 'function'
          ? loadingComponent(<LoadingIndicator indicatorSize={indicatorSize} />)
          : loadingComponent) ?? <LoadingIndicator indicatorSize={indicatorSize} />)
      ) : (
        <>
          {isLoading && <LoadingIndicator indicatorSize={indicatorSize} />}
          {children}
        </>
      )}
    </div>
  );
}
